import React from "react";
import { PROBLEM, LETTER, ASSETS } from "../../mock";

const CTAOutline = ({ onClick }) => (
  <button
    onClick={onClick}
    data-testid="problem-cta"
    className="cta-glow mt-8 border border-[#3f639f] text-[#9db8e8] hover:bg-[#3f639f] hover:text-white font-mono text-xs tracking-[0.25em] uppercase px-8 py-4"
  >
    Reserve My Free Seat
  </button>
);

const ProblemLetter = () => {
  const scrollToForm = () => document.getElementById("register")?.scrollIntoView({ behavior: "smooth" });

  return (
    <>
      {/* [001] The Problem */}
      <section id="problem" className="relative py-28 overflow-hidden scroll-mt-24" data-testid="problem-section">
        <div
          className="absolute inset-0 bg-cover bg-center opacity-[0.14]"
          style={{ backgroundImage: `url(${ASSETS.blueprint})` }}
        />
        <div className="absolute inset-0 blueprint-grid opacity-20" />
        <div className="relative max-w-6xl mx-auto px-6">
          <p className="font-mono text-[10px] tracking-[0.35em] text-[#6f7d9f] uppercase mb-8 reveal">{PROBLEM.label}</p>
          <h2 className="font-heading uppercase text-white text-4xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tight max-w-4xl reveal" data-testid="problem-headline">
            VA Home Loans Should Not Feel Like Decoding{" "}
            <span className="text-[#6b9be8]">Fine Print.</span>
          </h2>
          <p className="mt-8 text-[#aeb9d4] leading-relaxed max-w-xl text-sm sm:text-base reveal">{PROBLEM.body}</p>
          <div className="reveal"><CTAOutline onClick={scrollToForm} /></div>
        </div>
      </section>

      {/* [002] Letter from the host */}
      <section className="relative py-28 border-t border-[#131c31]" data-testid="letter-section">
        <div className="max-w-3xl mx-auto px-6">
          <p className="font-mono text-[10px] tracking-[0.35em] text-[#6f7d9f] uppercase mb-12 text-center reveal">{LETTER.label}</p>
          <div className="border border-[#1c2740] bg-[#0c1324]/70 p-8 sm:p-12 reveal">
            <p className="font-heading text-white text-2xl uppercase tracking-tight mb-6">{LETTER.salutation}</p>
            <p className="text-[#c3cde2] leading-relaxed mb-6">{LETTER.intro}</p>
            <div className="space-y-4 mb-8">
              {LETTER.myths.map((m, i) => (
                <div key={i} className="border-l-2 border-[#d4a24a] pl-4 text-[#d8c6a4] italic text-sm sm:text-base">{m}</div>
              ))}
            </div>
            {LETTER.paragraphs.map((p, i) => (
              <p key={i} className="text-[#aeb9d4] leading-relaxed mb-5 text-sm sm:text-base">{p}</p>
            ))}
            <p className="font-mono text-xs tracking-[0.15em] text-[#6b9be8] mt-8">{LETTER.signature}</p>
          </div>
        </div>
      </section>
    </>
  );
};

export default ProblemLetter;
